/**
 * LocalStorage helper voor "laatst gebruikte contactpersoon per Account".
 *
 * Wordt gebruikt door de B2B-order-flow (KlantDetailView): bij reorder pakken we
 * automatisch de eerder gekozen contact op zodat de picker niet steeds opent
 * voor dezelfde wederverkoper. Per browser/medewerker — geen server-state nodig.
 */

const KEY = (accountId: string) => `cinco.office.lastContactByAccount.${accountId}`;

export function getLastUsedContact(accountId: string): string | null {
  try {
    return localStorage.getItem(KEY(accountId));
  } catch {
    return null;
  }
}

export function setLastUsedContact(accountId: string, contactId: string): void {
  try {
    localStorage.setItem(KEY(accountId), contactId);
  } catch {
    // Quota / privacy mode — silently negeren, fallback is altijd de picker
  }
}
